import Store from 'store/store';
import { post, request } from 'utils/api';
import * as jsonPointer from 'utils/jsonPointer';

export async function prepareDomainTenant(path, vanityDomain) {
	const data = jsonPointer.get(Store.get().data, path);
	if (!data?.id) {
		throw new Error(`Data not found at path ${path}`);
	}
	if (!data.thundr_id) {
		throw new Error('This movie needs to be published at least once before a custom domain can be set up');
	}
	return await post('/movies/domain/prepare', {
		movie_id: data.id,
		vanityDomain,
		titlePath: String(data.thundr_id),
	});
}

export async function getDomainTenantStatus(path) {
	const data = jsonPointer.get(Store.get().data, path);
	if (!data?.id) {
		throw new Error(`Data not found at path ${path}`);
	}
	return await request(`/movies/domain/status/${data.id}`);
}

export async function activateDomainTenant(path) {
	const data = jsonPointer.get(Store.get().data, path);
	if (!data?.id) {
		throw new Error(`Data not found at path ${path}`);
	}
	try {
		return await post('/movies/domain/activate', { movie_id: data.id });
	} catch (err) {
		if (err.code === 409) {
			const body = await err.response?.json?.().catch(() => null);
			err.notReady = true;
			err.certificateStatus = body?.certificateStatus;
		}
		throw err;
	}
}

export async function cleanupDomainTenant(path, { deleteCertificate = true } = {}) {
	const data = jsonPointer.get(Store.get().data, path);
	if (!data?.id) {
		throw new Error(`Data not found at path ${path}`);
	}
	return await post('/movies/domain/cleanup', {
		movie_id: data.id,
		deleteCertificate,
	});
}